import { createAction, props } from '@ngrx/store';

// Sidebar actions
export const toggleSidebar = createAction('[Layout] Toggle Sidebar');
export const showSidebar = createAction('[Layout] Show Sidebar');
export const hideSidebar = createAction('[Layout] Hide Sidebar');

// Header actions
export const toggleHeader = createAction('[Layout] Toggle Header');
export const showHeader = createAction('[Layout] Show Header');
export const hideHeader = createAction('[Layout] Hide Header');

// Footer actions
export const toggleFooter = createAction('[Layout] Toggle Footer');
export const showFooter = createAction('[Layout] Show Footer');
export const hideFooter = createAction('[Layout] Hide Footer');

// Combined layout actions
export const toggleLayout = createAction('[Layout] Toggle Layout');
export const showLayout = createAction('[Layout] Show Layout');
export const hideLayout = createAction('[Layout] Hide Layout');
export const setLayoutVisibility = createAction(
  '[Layout] Set Layout Visibility',
  props<{ sidebarVisible: boolean; headerVisible: boolean; footerVisible: boolean }>()
);
